/* Simple wrapper to give us lodash as an injectable dependency */
angular.module('PatientApp').value('_', window._);